var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex flex-col desc-con" },
    _vm._l(_vm.describe, function (item) {
      return _c(
        "div",
        { key: item.id, staticClass: "item flex flex-row align-center" },
        [
          _c("span", { staticClass: "label" }, [_vm._v(_vm._s(item.label))]),
          _c("span", { staticClass: "value text-ellipsis" }, [
            _vm._v(_vm._s(item.value) + " "),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }